import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d66b30e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RaffleManage" }
const _hoisted_2 = { class: "itemModal" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"16px"} }, " 是否调整当前活动状态？？？ ", -1))
const _hoisted_4 = { class: "dialog-footer" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {initEmptyParam} from "@/hooks/useInitParam";
import {ref} from 'vue'
import {useRouter} from "vue-router";
import {useStore} from "@/store";
import {getListData, postData} from "@/service/main/system";


export default /*#__PURE__*/_defineComponent({
  __name: 'RaffleManage',
  setup(__props) {

initEmptyParam()

const modalTitle = ref('新增')
const status = ref(false)
const newCb = () => {
  modalTitle.value = '新增'
}

const editCb = () => {
  modalTitle.value = '编辑'
}

const tipDialogVisible = ref(false)
let queryItemInfo = {}
let changeInfo = ref()
const changeRaffleStats = (item: any) => {
  if (item.id != undefined) {
    tipDialogVisible.value = true
    changeInfo.value = item
  }
}

const tipDialog = async (item: any) => {
  if (item) {
    queryItemInfo = {id: changeInfo.value.id, raffleStatus: changeInfo.value.raffleStatus}
    try {
      await postData('/main/raffleManage/activation', queryItemInfo).then((res) => {
        tipDialogVisible.value = false
        initData()
      })
    } catch (e) {
      tipDialogVisible.value = false
      initData()
    }
  } else {
    tipDialogVisible.value = false
    initData()
  }
}

const initData = () => {
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const router = useRouter()
const store = useStore()
const handleFillClick = (item: any) => {
  const reportUrl = router.resolve({
    path: '/main/raffle/raffleManage/fill',
    query: {
      ...item
    }
  }).href
  popupWindowView(reportUrl, '新增')
}

const handleDetailData = async (item: any) => {
  let data = await getListData(
    "/main/raffleManage/queryById",
    {id: item.id}
  )
  const reportUrl = router.resolve({
    path: '/main/raffle/raffleManage/detail',
    query: {
      ...data
    }
  }).href
  popupWindowView(reportUrl, '编辑')
}

const handleRaffleRecord = async (item: any) => {
  const reportUrl = router.resolve({
    path: '/main/raffle/raffleRecord/record',
    query: {id: item.id, uuid: item.uuid}
  }).href
  popupWindowView(reportUrl, '记录')
}

const popupWindowView = (reportUrl: any, target: any) => {
  // 获取屏幕的宽度和高度
  const screenWidth = window.screen.width
  const screenHeight = window.screen.height

  const width = screenWidth * 0.6
  const height = screenHeight * 0.8

  // 计算新窗口的左上角位置，使其居中
  const leftPosition = screenWidth / 2 - width / 2
  const topPosition = screenHeight / 2 - height / 2

  // 创建弹出窗口
  const options = `width=${width},height=${height},left=${leftPosition},top=${topPosition - 50},toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`
  const popupWindow = window.open(reportUrl, target, options)
  if (popupWindow) {
    popupWindow.onbeforeunload = function () {
      const queryInfo = store.state.system.queryInfo
      pageContentRef.value?.getPageData(queryInfo)
    }
  }
}

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "raffleManage",
      deleteTip: "确认删除当前活动？",
      onNewBtnClick: handleFillClick,
      onDetailClick: handleDetailData
    }, {
      status: _withCtx((scope) => [
        _createVNode(_component_el_switch, {
          modelValue: scope.row.raffleStatus,
          "onUpdate:modelValue": ($event: any) => ((scope.row.raffleStatus) = $event),
          "active-value": "1",
          "inactive-value": "0",
          onChange: ($event: any) => (changeRaffleStats(scope.row))
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
      ]),
      raffleName: _withCtx((scope) => [
        _createVNode(_component_el_link, {
          class: "text-link",
          onClick: _withModifiers(($event: any) => (handleRaffleRecord(scope.row)), ["stop","prevent"])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.raffleName), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["contentTableConfig"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_dialog, {
        modelValue: tipDialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tipDialogVisible).value = $event)),
        title: "活动状态变更",
        width: "30%",
        "destroy-on-close": "",
        center: ""
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (tipDialog(false)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (tipDialog(true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("确认")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})